export class UI {
  constructor(game) {
    this.game = game;
    this.uiContainer = null;
    this.countdownContainer = null;
    this.scoreContainer = null;
    this.timerContainer = null;
    this.pauseMenu = null;
    this.modeSelectScreen = null;
    
    // Initialize UI
    this.init();
  }
  
  init() {
    // Create UI container if it doesn't exist
    if (!document.getElementById('ui-container')) {
      this.uiContainer = document.createElement('div');
      this.uiContainer.id = 'ui-container';
      document.body.appendChild(this.uiContainer);
    } else {
      this.uiContainer = document.getElementById('ui-container');
    }
    
    // Create mode select screen
    this.createModeSelectScreen();
    
    // Create pause menu
    this.createPauseMenu();
  }
  
  createModeSelectScreen() {
    // Remove existing mode select screen if it exists
    const existingScreen = document.getElementById('mode-select-screen');
    if (existingScreen) {
      existingScreen.remove();
    }
    
    // Create new mode select screen
    this.modeSelectScreen = document.createElement('div');
    this.modeSelectScreen.id = 'mode-select-screen';
    this.modeSelectScreen.className = 'menu-screen';
    
    // Create content
    this.modeSelectScreen.innerHTML = `
      <div class="menu-container">
        <h1>Football Vibes</h1>
        
        <div class="mode-buttons">
          <div class="mode-button" id="mode-1v1">
            <h2>1v1 Mode</h2>
            <p>Play against a bot</p>
          </div>
          
          <div class="mode-button" id="mode-2v2">
            <h2>2v2 Mode</h2>
            <p>Play in a 2v2 match</p>
          </div>
        </div>
        
        <div class="menu-footer">
          <p>More Modes Coming Soon</p>
          <p>Stay tuned for updates!</p>
        </div>
      </div>
    `;
    
    // Add to DOM
    document.body.appendChild(this.modeSelectScreen);
    
    // Add event listeners
    document.getElementById('mode-1v1').addEventListener('click', () => {
      this.game.setGameMode('1v1');
      this.game.startGame();
    });
    
    document.getElementById('mode-2v2').addEventListener('click', () => {
      this.game.setGameMode('2v2');
      this.game.startGame();
    });
  }
  
  createPauseMenu() {
    // Remove existing pause menu if it exists
    const existingPauseMenu = document.getElementById('pause-menu');
    if (existingPauseMenu) {
      existingPauseMenu.remove();
    }
    
    // Create new pause menu
    this.pauseMenu = document.createElement('div');
    this.pauseMenu.id = 'pause-menu';
    this.pauseMenu.className = 'menu-screen hidden';
    
    // Create content
    this.pauseMenu.innerHTML = `
      <div class="menu-container">
        <h1>Game Paused</h1>
        
        <div class="menu-buttons">
          <button id="resume-button">Resume Game</button>
          <button id="restart-button">Restart Game</button>
          <button id="main-menu-button">Main Menu</button>
        </div>
      </div>
    `;
    
    // Add to DOM
    document.body.appendChild(this.pauseMenu);
    
    // Add event listeners
    document.getElementById('resume-button').addEventListener('click', () => {
      this.game.togglePause();
    });
    
    document.getElementById('restart-button').addEventListener('click', () => {
      this.hidePauseMenu();
      this.game.isPaused = false;
      this.game.startGame();
    });
    
    document.getElementById('main-menu-button').addEventListener('click', () => {
      this.hidePauseMenu();
      this.game.isPaused = false;
      this.game.isGameActive = false;
      this.showModeSelectScreen();
    });
  }
  
  createTimerDisplay() {
    // Remove existing timer display if it exists
    if (this.timerContainer) {
      this.timerContainer.remove();
    }
    
    // Create new timer display
    this.timerContainer = document.createElement('div');
    this.timerContainer.id = 'timer-container';
    this.timerContainer.className = 'ui-element';
    this.uiContainer.appendChild(this.timerContainer);
  }
  
  updateTimerDisplay(timeRemaining) {
    if (!this.timerContainer) return;
    
    // Format time as 0:00
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = Math.floor(timeRemaining % 60).toString().padStart(2, '0');
    this.timerContainer.innerHTML = `${minutes}:${seconds}`;
  }
  
  createScoreDisplay() {
    // Remove existing score display if it exists
    if (this.scoreContainer) {
      this.scoreContainer.remove();
    }
    
    // Create new score display
    this.scoreContainer = document.createElement('div');
    this.scoreContainer.id = 'score-container';
    this.scoreContainer.className = 'ui-element';
    this.uiContainer.appendChild(this.scoreContainer);
  }
  
  updateScore(blueScore, orangeScore) {
    if (!this.scoreContainer) {
      this.createScoreDisplay();
    }
    
    this.scoreContainer.innerHTML = `<span class="blue-score">${blueScore}</span> - <span class="orange-score">${orangeScore}</span>`;
  }
  
  showCountdown(countdownTime) {
    // Remove existing countdown display if it exists
    if (this.countdownContainer) {
      this.countdownContainer.remove();
    }
    
    // Create new countdown display
    this.countdownContainer = document.createElement('div');
    this.countdownContainer.id = 'countdown-container';
    this.countdownContainer.className = 'ui-element';
    this.countdownContainer.innerHTML = countdownTime.toString();
    this.uiContainer.appendChild(this.countdownContainer);
  }
  
  updateCountdown(count) {
    if (!this.countdownContainer) return;
    
    this.countdownContainer.innerHTML = count.toString();
  }
  
  hideCountdown() {
    if (this.countdownContainer) {
      this.countdownContainer.classList.add('hidden');
      
      // Remove after animation completes
      setTimeout(() => {
        if (this.countdownContainer) {
          this.countdownContainer.remove();
          this.countdownContainer = null;
        }
      }, 500);
    }
  }
  
  showGoalMessage(team) {
    const goalMessage = document.createElement('div');
    goalMessage.id = 'goal-message';
    goalMessage.className = `ui-element ${team}-team`;
    goalMessage.innerHTML = `<span class="goal-text">GOAL!</span>`;
    this.uiContainer.appendChild(goalMessage);
    
    // Remove after animation
    setTimeout(() => {
      goalMessage.classList.add('fade-out');
      setTimeout(() => {
        goalMessage.remove();
      }, 500);
    }, 1500);
  }
  
  showGameOver(winner, score) {
    const gameOverScreen = document.createElement('div');
    gameOverScreen.id = 'game-over-screen';
    gameOverScreen.className = 'menu-screen';
    
    // Create content based on winner
    let resultMessage = '';
    if (winner === 'blue') {
      resultMessage = 'You Win!';
    } else if (winner === 'orange') {
      resultMessage = 'You Lose!';
    } else {
      resultMessage = 'It\'s a Tie!';
    }
    
    gameOverScreen.innerHTML = `
      <div class="menu-container">
        <h1>Game Over</h1>
        <h2>${resultMessage}</h2>
        
        <div class="final-score">
          <span class="blue-score">${score.blue}</span> - <span class="orange-score">${score.orange}</span>
        </div>
        
        <div class="menu-buttons">
          <button id="play-again-button">Play Again</button>
          <button id="main-menu-button-end">Main Menu</button>
        </div>
      </div>
    `;
    
    // Add to DOM
    document.body.appendChild(gameOverScreen);
    
    // Add event listeners
    document.getElementById('play-again-button').addEventListener('click', () => {
      gameOverScreen.remove();
      this.game.startGame();
    });
    
    document.getElementById('main-menu-button-end').addEventListener('click', () => {
      gameOverScreen.remove();
      this.showModeSelectScreen();
    });
  }
  
  showModeSelectScreen() {
    // Hide all other screens
    this.hideMenuScreens();
    
    // Show mode select screen
    if (this.modeSelectScreen) {
      this.modeSelectScreen.classList.remove('hidden');
    } else {
      this.createModeSelectScreen();
    }
  }
  
  showPauseMenu() {
    if (this.pauseMenu) {
      this.pauseMenu.classList.remove('hidden');
    } else {
      this.createPauseMenu();
      this.pauseMenu.classList.remove('hidden');
    }
  }
  
  hidePauseMenu() {
    if (this.pauseMenu) {
      this.pauseMenu.classList.add('hidden');
    }
  }
  
  hideMenuScreens() {
    // Hide mode select screen
    if (this.modeSelectScreen) {
      this.modeSelectScreen.classList.add('hidden');
    }
    
    // Hide pause menu
    this.hidePauseMenu();
    
    // Hide game over screen
    const gameOverScreen = document.getElementById('game-over-screen');
    if (gameOverScreen) {
      gameOverScreen.classList.add('hidden');
      setTimeout(() => {
        gameOverScreen.remove();
      }, 500);
    }
  }
} 